const languageToCountryMap: Record<string, string> = {
  DA: "DK", // Danish
  DE: "DE", // German
  FI: "FI", // Finnish
  NB: "NO", // Norwegian Bokmål
  NN: "NO", // Norwegian Nynorsk
  NO: "NO", // Norwegian
  SV: "SE", // Swedish
}

export const convertLanguageToCountryCode = (
  languageCode: keyof typeof languageToCountryMap,
): string => {
  return languageToCountryMap[languageCode.toUpperCase()] || languageCode
}
